var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtendedViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.9 19.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1b64ae;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#4e98d3;}.cls-3{fill:#cae3f8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3072",
    className: "cls-2",
    d: "m18.73,5.27v4.1h-3.51v-4.1h-1.17v4.1h-3.51v-4.1h-1.17v4.1h-4.1v1.17h4.1v3.51h-4.1v1.17h4.1v3.51h-4.1v1.17h14.63V5.27h-1.17Zm0,5.27v3.51h-3.51v-3.51h3.51Zm-8.2,0h3.52v3.51h-3.51v-3.51Zm0,4.68h3.52v3.51h-3.51v-3.51Zm4.68,3.51v-3.51h3.51v3.51h-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3073",
    className: "cls-3",
    d: "m19.32.59H.59v18.73h4.68V5.27h14.05V.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3074",
    className: "cls-1",
    d: "m0,0v19.9h5.85V5.85h14.05V0H0Zm1.17,9.37v-3.51h3.51v3.51H1.17Zm3.51,1.17v3.51H1.17v-3.51h3.51ZM5.85,1.17h3.51v3.51h-3.51V1.17Zm4.68,0h3.51v3.51h-3.51V1.17Zm-5.85,0v3.51H1.17V1.17h3.51ZM1.17,18.73v-3.51h3.51v3.51H1.17ZM18.73,4.68h-3.51V1.17h3.51v3.51Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendedViewIcon);
export default __webpack_public_path__ + "static/media/extended-view-icon.bb2ef6e1.svg";
export { ForwardRef as ReactComponent };